import { createModel, RematchDispatch } from '@rematch/core';
import * as assignedContactApi from '../../services/assignedUserContact.service';
import { AssignedUserContactType } from '../../types/CMSUserContactTypes';
import { PaginationType } from '../../types/CommonTypes';
import { RootModel } from '../models';
import baseEntity from './base.entity';

export const storeName = 'assignedUserContactEntity';

export const assignedUserContactEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof assignedUserContactEntity>) => ({
    async load(payload): Promise<{ content: AssignedUserContactType[] } & PaginationType> {
      try {
        const res = await assignedContactApi.filter(payload);
        const { content } = res.data;
        if (content && content.length) {
          this.saveSimplified(content);
        }
        return res.data;
      } catch (e) {
        throw new Error(e);
      }
    },
    async assign(payload) {
      try {
        const { data: items = [] } = await assignedContactApi.assign(payload);
        if (items.length) {
          this.saveSimplified(items);
        }
      } catch (e) {
        throw new Error(e);
      }
    },
  }),
});

export default assignedUserContactEntity;
